import { center, flexRoot } from 'csstips';
import { important, px } from 'csx';
import React from 'react';
import { classes, style } from 'typestyle';
import { rebrand } from '../../../theme/color';
import { CheckmarkCircle } from '../atoms/icons/CheckmarkCircle';
import { StarCircle } from '../atoms/icons/StarCircle';

interface Props {
  isStock: boolean;
  isAvailable?: boolean;
  className?: string;
}

const styles = {
  wrapper: style(flexRoot, center, {
    $nest: {
      '& span': {
        marginRight: px(4),
      },
    },
  }),
  premium: style({
    color: rebrand.primary[100].toHexString(),
  }),
  unavailablePremium: style({
    color: important(rebrand.primary[20].toString()),
  }),
  icon: style({
    marginLeft: px(4),
    flexShrink: 0,
  }),
};

export const CatalogueLabel: React.FC<Props> = ({ isStock, isAvailable = true, className, ...rest }) => {
  const wrapperClasses = !isStock
    ? classes(styles.wrapper, styles.premium, !isAvailable && styles.unavailablePremium, className)
    : classes(styles.wrapper, className);

  return (
    <div className={wrapperClasses} {...rest}>
      {isStock ? 'Included' : 'Premium'}

      {isStock ? (
        <CheckmarkCircle
          className={styles.icon}
          color={rebrand.dark1.toString()}
          checkColor={rebrand.highlight1.toString()}
          size={15}
        />
      ) : (
        <StarCircle
          className={styles.icon}
          color={!isAvailable ? rebrand.primary[20].toString() : rebrand.primary[100].toHexString()}
          size={13}
        />
      )}
    </div>
  );
};
